import { Component, OnInit, Output, EventEmitter, ViewEncapsulation, ViewChild, TemplateRef, Input } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { QueryInterface } from 'app/shared/common/parse/query-interface';
import { ParseService } from 'app/shared/common/parse/parse.service';
import { FormGroup, Validators, FormBuilder } from '@angular/forms';
import { GetterSetter } from 'app/shared/common/helper/project';
import { DateConvertor } from 'app/shared/common/helper/dateConvertor';
import { ToastrService } from 'ngx-toastr';
import { ToastBaseModel } from 'app/shared/common/toast-data-model';
import { GetOperations } from 'app/shared/common/helper/dropdown';
import { StorageConfiguration } from 'app/shared/common/storage-setting/storage-configuration';
import { MatDialog, MatTableDataSource } from '@angular/material';
import { ScrumboardService } from 'app/main/pages/scrumboard/scrumboard.service';
import { CommonValidation } from 'app/shared/common/common-validation';
import axios from 'axios';
import { fuseAnimations } from '@fuse/animations';
import { HardCodedValues } from 'app/shared/common/hard-coded-values';
import { DatePipe } from '@angular/common';
import { ActivityCenterService } from 'app/shared/common/helper/activity-center';

@Component({
  selector: 'app-information',
  templateUrl: './information.component.html',
  styleUrls: ['./information.component.scss'],
  encapsulation: ViewEncapsulation.None,
  animations: fuseAnimations
})
export class InformationComponent implements OnInit {

  // billables = [
  //   { id: 'Fixed Billable', Billable: 'Fixed Billable ' },
  //   { id: 'Fixed Non-Billable', Billable: 'Fixed Non-Billable ' },
  //   { id: 'Time and Material Billable', Billable: 'Time and Material Billable ' },
  //   { id: 'Time and Material Non-Billable', Billable: 'Time and Material Non-Billable' },
  // ];

  isEdit: boolean;
  objectId = '';
  empRole = '';
  projectInformationForm: FormGroup;
  projectInformation: any;
  OtherInformationForm: FormGroup;
  projectValue: any;
  startdate: any;
  enddate: any;
  show: boolean = true;
  statusdisable: boolean = false;
  projectId: any;
  startDate: any;
  endday: any;
  clientList = [];
  platformList = [];
  projectLists = [];
  projectStatusList = [];
  resourcesLists = [];
  gitupLists = [];
  statusLists = [];
  fileToUpload: File = null;
  resourceHistory = [];
  selectedRows: any[];
  resourceDropdown = [];
  isResourceChanged = false;
  resourceDetails = [];
  assignedResources = [];
  projectStatus: any;
  nonBillableCount = [];
  statusReason: any;
  projectActivities = [];
  @ViewChild("scrumboard", { static: false }) scrumboard: TemplateRef<any>;
  @Output() isEditValue = new EventEmitter<boolean>();
  @Output() projectType = new EventEmitter<string>();
  @Output() createdProjectId = new EventEmitter<string>();
  projectStartDate: string = '';
  actualCompletionDate: string = '';
  extendedCompletionDate: string = '';
  resourceDetailDate: string = '';
  displayedColumn: string[] = ['role', 'count', 'hours', 'delete'];
  displayedColumns: string[] = ['role', 'count', 'hours'];
  resourceHistoryTableColumn: string[] = ['name', 'role', 'status'];
  dataSources = new MatTableDataSource<resourceTableModel>([]);
  totalCount = 0;
  totalHours = 0;
  srs = [];
  plan = [];
  reason = false;
  currentUser = this.parseService.instance.User.current();
  currentProjectDetails: any;
  noOfResource: any[] = [
    { value: 0, viewValue: '0' },
    { value: 1, viewValue: '1' },
    { value: 2, viewValue: '2' },
    { value: 3, viewValue: '3' },
    { value: 4, viewValue: '4' },
    { value: 5, viewValue: '5' },
    { value: 6, viewValue: '6' },
    { value: 7, viewValue: '7' },
    { value: 8, viewValue: '8' },
    { value: 9, viewValue: '9' },
    { value: 10, viewValue: '10' },
    { value: 11, viewValue: '11' },
    { value: 12, viewValue: '12' },
    { value: 13, viewValue: '13' },
    { value: 14, viewValue: '14' },
    { value: 15, viewValue: '15' }
  ];
  addons: any[] = [
    { value: 'Addon', viewValue: 'Addon' },
    { value: 'Support', viewValue: 'Support' },
    { value: 'Task', viewValue: 'Task' }
  ];
  currentResourceDetail: any;
  @ViewChild('projectDialog', { static: false }) projectDialog: TemplateRef<any>;
  profileId: any;
  srsId: string;
  previousReason: any;
  firstname: any;
  lastname: any;
  currentResourcetDetails: any;
  typeOfProject: any;
  supportBillableCount: any[];
  projectReason: any;
  projecttypeInfo: any;
  supportBillable: number;
  projectTypeCheck: any;
  apiUrl: any;
  scrumBoard = false;
  currentDetails: any;
  projectName: any;
  @Input() projectIdValue: any;
  tenantId: any;

  constructor(
    private route: ActivatedRoute,
    private queryInterface: QueryInterface,
    private parseService: ParseService,
    private formBuilder: FormBuilder,
    private projectInterface: GetterSetter,
    private dateConvertor: DateConvertor,
    private toastr: ToastrService,
    private toastMessage: ToastBaseModel,
    private profileDropDown: GetOperations,
    private storageConfiguration: StorageConfiguration,
    public dialog: MatDialog,
    public router: Router,
    private _scrumboardService: ScrumboardService,
    private commonValidation: CommonValidation,
    private hardCodedValues: HardCodedValues,
    private activityCenterService: ActivityCenterService
  ) {

    this.projectInformationForm = this.formBuilder.group({
      clientName: ['', Validators.required],
      projectName: ['', Validators.required],
      projectType: ['', Validators.required],
      currentStatus: [''],
      // projectStartDate: ['', Validators.required],
      reason: [''],
      // actualCompletionDate: [''],
      // extendedCompletionDate: [''],
      projectDescription: [''],
      addOnType: [''],
      // projectPlatform: ['', Validators.required],
      schedulerStatus: [''],
      srs: [],
      plan: []
    });
    this.tenantId = this.storageConfiguration.sessionGetItem(this.storageConfiguration.tenantId);
  }

  async ngOnInit() {
    
    let queryInstance = this.parseService.instance.Object.extend('DataSettings');
    let query = new this.parseService.instance.Query(queryInstance);
    await query.find().then(result => {
      this.apiUrl = result[0].get('apiUrl');
    });
    this.firstname = this.parseService.instance.User.current().get('firstName');
    this.lastname = this.parseService.instance.User.current().get('lastName');
    this.empRole = this.storageConfiguration.sessionGetItem(
      this.storageConfiguration.role
    );
    this.isEdit = false;
    this.route.params.subscribe(params => {
      this.objectId = params['id'];
      if (this.objectId != '' && this.objectId != undefined) {
        this.isEdit = true;
        this.getProjectInformation();
      }
    });
    if (this.projectIdValue != '' && this.projectIdValue != undefined) {
      this.objectId = this.projectIdValue;
      this.isEdit = true;
      this.getProjectInformation();
    }
    this.createForm();
    this.getResourceType();
    this.getClient();
    this.getDropDowns();

  }

  /*
  ** ==========================================================
  ** Check Scrumboard
  ** ==========================================================
  */
  checkScrumboard() {
    this.queryInterface.executeQuery(this.parseService, 'Sprint', [{ condition: 'include', field: 'project' },
    { condition: 'equalTo', field: 'project', value: { __type: 'Pointer', className: 'Project', objectId: this.currentProjectDetails.id } }]).then(res => {
      if (res.length > 0) {
        this.scrumBoard = false;
      }
      else {
        this.scrumBoard = true;
      }
    });
  }

  createForm() {
    this.OtherInformationForm = this.formBuilder.group({
      githubStatus: ['', Validators.required],
      estimatedDays: [''],
      estimatedCost: ['']
    });
  }

  addOnType(event) {
    if (event.value == 'Support') {
      this.projectInformationForm.patchValue({
        projectType: ''
      });
    }
  }

  public hide(event) {
    if (event.value == 'Dedicated' || event.value == 'Support') {
      this.show = false;
    } else if (event.value == 'Fixed' || event.value == 'Task') {
      this.show = true;
    }
    this.projectType.emit(event.value);
  }

  /*
  ** ==========================================================
  ** Get dropdown values
  ** ==========================================================
  */
  async getDropDowns() {
    let queryInstance = this.parseService.instance.Object.extend('DataSettings');
    let query = new this.parseService.instance.Query(queryInstance);
    let result = await query.find();
    var dropdownresults = result[0],
      profileDropDownValue = this.profileDropDown.getProfileDropDown(
        dropdownresults
      ),
      projectPlatformsobj = this.platformList,
      projectTypeObj = this.projectLists,
      currentStatusObj = this.projectStatusList,
      resourceObj = this.resourcesLists,
      gitStatusObj = this.gitupLists,
      statusPopupObj = this.statusLists,
      statusLists = profileDropDownValue.popupStatus,
      resourcesLists = profileDropDownValue.resourceType,
      gitupLists = profileDropDownValue.gitStatus,
      projectStatusList = profileDropDownValue.currentStatus,
      projectLists = profileDropDownValue.projectType,
      platformList = profileDropDownValue.projectPlatforms;
    for (var i = 0; i < platformList.length; i++) {
      projectPlatformsobj.push(platformList[i]);
    }
    for (var i = 0; i < resourcesLists.length; i++) {
      resourceObj.push(resourcesLists[i]);
    }
    for (var i = 0; i < projectLists.length; i++) {
      projectTypeObj.push(projectLists[i]);
    }
    for (var i = 0; i < projectStatusList.length; i++) {
      currentStatusObj.push(projectStatusList[i]);
    }
    for (var i = 0; i < gitupLists.length; i++) {
      gitStatusObj.push(gitupLists[i]);
    }
    for (var i = 0; i < statusLists.length; i++) {
      statusPopupObj.push(statusLists[i]);
    }
  }

  /*
  ** ==========================================================
  ** File Upload
  ** ==========================================================
  */
  fileUpload(event, type) {

    var formData = new FormData();
    if (event.target.files.length > 0) {
      const file = event.target.files[0];
      if (file.type == 'application/pdf' || file.type == 'application/vnd.openxmlformats-officedocument.wordprocessingml.document' || file.type == 'application/msword' || file.type == 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' || file.type == 'application/vnd.ms-excel') {
        formData.append('files', file);
        var session = this.storageConfiguration.sessionGetItem(this.storageConfiguration.sessiontoken);
        axios.post(this.apiUrl.mediaPath, formData, {
          headers: {
            // 'authorization': 'Bearer r:275fc76ef2168814a16b37a759eb538c',
            'authorization': 'Bearer ' + session,
            'Content-Type': 'application/x-www-form-urlencoded'
          }
        }).then(responseData => {
          var response = responseData;
          const name = response.data.url.split('/');
          if (type == 'srs') {
            this.srs.push({ id: response.data._id, name: name[4], url: response.data.url });
          } else if (type == 'plan') {
            this.plan.push({ id: response.data._id, name: name[4], url: response.data.url });
          }
          this.toastr.success('File Uploaded Successfully');

          let activityNew = [];
          let message = ' Added a file ' + response.data.url;
          activityNew.push(this.setActivityModel(message));
          activityNew.forEach(element => {
            this.projectActivities.unshift(element);
          });
          let id = '';
          id = this.empRole == 'Admin' ? this.objectId : this.projectId;

          this.activityCenterService.createActivity(activityNew, this.hardCodedValues.project, id);

          this.queryInterface.executeQuery(this.parseService, 'Project', [
            { condition: 'equalTo', field: 'objectId', value: id }])
            .then(result => {
              var results = result[0];
              results.set('activities', this.projectActivities);
              results.save().then(res => {
              });
            });

        }).catch(err => {
          if (err.message == 'Network Error') {
            this.toastr.warning('Please upload Document, excel and Pdf files only');
          }
          if (err.response.data.message == 'Please upload the image less than 500kb') {
            this.toastr.warning('Please upload the file less than 500kb');
          }
        });
      } else {
        this.toastr.warning('Please upload Document, excel and Pdf files only');
      }
    }
  }

  /*
  ** ==========================================================
  ** Delete File
  ** ==========================================================
  */
  deleteFile(id, type) {
    const fileId = id;
    var session = this.storageConfiguration.sessionGetItem(this.storageConfiguration.sessiontoken);
    axios.delete(this.apiUrl.mediaPath + id, {
      headers: {
        "authorization": "Bearer " + session,
        'Content-Type': 'application/json'
      }
    }).then(aresf => {
      var response = aresf;
      let fileIndex;
      if (type == 'srs') {
        fileIndex = this.srs.findIndex(x => x.id == fileId);
        this.srs.splice(fileIndex, 1);
      } else if (type == 'plan') {
        fileIndex = this.plan.findIndex(x => x.id == fileId);
        this.plan.splice(fileIndex, 1);
      }

      let proId = this.empRole == 'Admin' ? this.objectId : this.projectId;
      if (proId != undefined) {
        this.updateProjectInformation();
      }

      let activityNew = [];
      // tslint:disable-next-line: max-line-length
      let message = ' Removed a file ' + fileId;
      activityNew.push(this.setActivityModel(message));
      activityNew.forEach(element => {
        this.projectActivities.unshift(element);
      });

      let id = '';
      id = this.empRole == 'Admin' ? this.objectId : this.projectId;

      this.activityCenterService.createActivity(activityNew, this.hardCodedValues.project, id);
      this.queryInterface.executeQuery(this.parseService, 'Project', [
        { condition: 'equalTo', field: 'objectId', value: id }]).then(result => {
          var results = result[0];
          results.set('activities', this.projectActivities);
          results.save().then(res => {
          });
        });
    }).catch(err => {
      this.toastr.warning(err.response.data.message);
    });
  }

  /*
  ** ==========================================================
  ** Get Client Details
  ** ==========================================================
  */
  getClient() {
    var clientName = [];
    const result = [];
    this.queryInterface.executeQuery(this.parseService, 'Client', [{ field: 'name', condition: 'descending' }, { condition: 'limit', value: 10000 }, { condition: 'equalTo', field: 'tenantId', value: this.tenantId },
    ]).then(results => {
      const jsonText = JSON.stringify(results);
      const clients = JSON.parse(jsonText);
      for (const client of clients) {
        clientName = client.companyInfo.firstName;
        this.clientList.push({
          id: client.objectId,
          name: clientName.concat(' ' + client.companyInfo.lastName)
        });
      }
    });
  }

  changeCount(val, rowData) {
    let res = [];
    if (rowData != '') {
      res = this.assignedResources.filter(x => x.role == rowData.role);
    }
    if (res.length > val) {
      const count = res.length - val;
      this.toastr.warning('Please release ( ' + count + ' ' + rowData.role + '  Resource ) before reducing count');
      this.getProjectInformation();

    } else {
      this.isResourceChanged = true;
      this.totalCount = 0;
      this.dataSources.data.forEach(element => {
        this.totalCount += element.count;
      });
      // this.totalCount = this.totalCount + event;
    }

  }

  changeHourCount(event) {
    // this.totalHours = this.totalHours + event;
    this.isResourceChanged = true;
    this.totalHours = 0;
    this.dataSources.data.forEach(element => {
      this.totalHours += element.hours;
    });
  }

  getCount() {
    let total = 0;
    this.dataSources.data.forEach(element => {
      total = element.count + total;
    });
    return total;
  }

  getHoursCount() {
    let total = 0;
    this.dataSources.data.forEach(element => {
      total += element.hours;
    });
    return total;
  }

  /*
  ** ==========================================================
  ** Get Project Information
  ** ==========================================================
  */
  getProjectInformation() {
    let condition = [];
    let type = '';
    if (this.empRole == 'Admin') {
      condition = [
        { condition: 'equalTo', field: 'objectId', value: this.objectId },
        { condition: 'include', value: 'client' }
      ];
      type = 'Project';
    } else {
      condition = [
        { condition: 'include', value: 'project' },
        { condition: 'include', value: 'project.client' },
        { condition: 'include', value: 'user' },
        {
          condition: 'equalTo', field: 'project', value: {
            __type: 'Pointer',
            className: 'Project',
            objectId: this.objectId
          }
        }
      ];
      type = 'ProjectMembers';
    }
    this.queryInterface.executeQuery(this.parseService, type, condition).then(results => {
      const result = results[0];
      if (this.empRole == 'Admin') {
        this.projectValue = this.projectInterface.getProject(result);
        this.projectActivities = this.projectValue.activities;
        this.currentProjectDetails = this.projectValue;

        this.currentResourcetDetails = JSON.parse(JSON.stringify(this.projectValue.resourceDetails.details));
        this.checkScrumboard();
        this.projectId = result.id;
        this.projectName = result.get('projectInfo').projectName;
      } else {
        this.projectValue = this.projectInterface.getProject(result.get('project'));
        this.currentProjectDetails = this.projectValue;

        this.currentResourcetDetails = JSON.parse(JSON.stringify(this.projectValue.resourceDetails.details));
        this.checkScrumboard();
        this.projectActivities = this.projectValue.activities;
        this.projectId = result.get('project').id;
      }
      this.projectTypeCheck = this.projectValue.projectType;

      this.dataSources.data = this.projectValue.resourceDetails.details;
      this.currentResourceDetail = JSON.parse(JSON.stringify(this.projectValue.resourceDetails));
      this.getResourceType();
      this.resourceDetailDate = this.projectValue.resourceDetails.resourceDetailDate;
      this.totalCount = this.getCount();
      this.totalHours = this.getHoursCount();
      this.startdate = this.projectValue.projectInfo.projectStartDate;
      this.enddate = this.projectValue.projectInfo.projectType;

      this.projecttypeInfo = JSON.parse(JSON.stringify(this.projectValue.projectInfo.projectType));

      this.projectValue.projectInfo.addOnType == 'Task' ? this.show = true : this.show = false;
      if (this.projectValue.projectInfo.projectType == 'Fixed') {
        this.show = true;
      }
      else if (this.projectValue.projectInfo.projectType == 'Dedicated') {
        this.show = false;
      }

      if (this.projectValue.projectInfo.currentStatus == 'Completed') {
        this.statusdisable = true;
      }
      // this.projectValue.projectInfo.projectType == 'Fixed' ? this.show = true : this.show = false;
      this.previousReason = this.projectValue.projectInfo.reason;

      this.typeOfProject = this.projectValue.projectInfo.addOnType;

      this.projectInformationForm.patchValue({
        clientName: this.projectValue.client,
        projectDescription: this.projectValue.projectInfo.projectDescription,
        projectName: this.projectValue.projectInfo.projectName,
        projectType: this.projectValue.projectInfo.projectType,
        currentStatus: this.projectValue.projectInfo.currentStatus,
        projectStartDate: this.projectValue.projectInfo.projectStartDate,
        projectPlatform: this.projectValue.projectInfo.projectPlatform,
        actualCompletionDate: this.projectValue.projectInfo.actualCompletionDate ? this.projectValue.projectInfo.actualCompletionDate : '',
        extendedCompletionDate: this.projectValue.projectInfo.extendedCompletionDate ? this.projectValue.projectInfo.extendedCompletionDate : '',
        reason: this.projectValue.projectInfo.reason == undefined ? '' : this.projectValue.projectInfo.reason,

        addOnType: this.projectValue.projectInfo.addOnType,
        schedulerStatus: this.projectValue.schedulerStatus ? this.projectValue.schedulerStatus : '',

      });
      this.currentDetails = JSON.parse(JSON.stringify(this.projectInformationForm.value));

      this.srs = this.projectValue.projectInfo.srs == null ? [] : this.projectValue.projectInfo.srs;
      this.plan = this.projectValue.projectInfo.plan == null ? [] : this.projectValue.projectInfo.plan;
      const id = this.empRole == 'Admin' ? this.objectId : this.projectId;
      this.getAssignedResources(id);
      this.projectType.emit(this.projectInformationForm.value.projectType);
      this.projectReason = this.projectValue.projectInfo.reason;
      if (this.projectValue.projectInfo.reason !== '' && this.projectValue.projectInfo.reason !== undefined) {
        this.status(this.projectReason);
      }
    });
  }

  nameChange(pname) {
    pname = this.nameCapitalChange(pname);
    this.projectInformationForm.patchValue({
      projectName: pname
    });
  }

  nameCapitalChange(event) {
    return event.charAt(0).toUpperCase() + event.slice(1);
  }

  changeDate(event) {
    var endDate = this.dateConvertor.momentChange(event.value);
    this.noOfDays();
  }

  noOfDays() {
    var projectStartDate = new Date(
      this.projectInformationForm.value.projectStartDate
    );
    var projectEndDate = new Date(
      this.projectInformationForm.value.actualCompletionDate
    );
    var oneDay = 24 * 60 * 60 * 1000;
    var dateDifferences = Math.round(
      Math.abs((projectStartDate.getTime() - projectEndDate.getTime()) / oneDay)
    );
    this.OtherInformationForm.patchValue({
      estimatedDays: dateDifferences
    });
    return dateDifferences;
  }

  /*
  ** ==========================================================
  ** Update Project Information
  ** ==========================================================
  */
  async updateProjectInformation() {
    let allowSave = true;
    const errorArray = [];

    const controls = this.projectInformationForm.controls;

    if (this.projectInformationForm.value.addOnType == 'Support' || this.projectInformationForm.value.addOnType == 'Task') {
      for (const value in controls) {
        if (controls[value].invalid) {
          if (value != 'projectType') {
            allowSave = false;
            errorArray.push(value);
          }
        }
      }
    } else {
      for (const value in controls) {
        if (controls[value].invalid) {
          allowSave = false;
          errorArray.push(value);
        }
      }
    }
    if (this.dataSources.data.length <= 0) {
      allowSave = false;
      errorArray.push('Resources');
    }
    const roleCheck = this.dataSources.data.filter(a => a.role == '');
    const resourceCheck = this.dataSources.data.filter(a => a.count == 0);
    const hourCheck = this.dataSources.data.filter(a => a.hours == 0 || a.hours == null);
    if (roleCheck.length > 0) {
      allowSave = false;
      errorArray.push('Role');
    }
    if (resourceCheck.length > 0) {
      allowSave = false;
      errorArray.push('No Of Resources');
    }
    if (hourCheck.length > 0 && (this.projectInformationForm.value.projectType == 'Fixed' || this.projectInformationForm.value.addOnType == 'Task')) {
      allowSave = false;
      errorArray.push('Hours');
    }

    const projectresourceDetails = this.currentResourceDetail;
    let currentResourceCount = 0;
    let oldResourceCount = 0;
    this.dataSources.data.forEach(element => {
      currentResourceCount += element.count;
    });
    projectresourceDetails.details.forEach(element => {
      oldResourceCount += element.count;
    });

    if (allowSave) {
      if (currentResourceCount != oldResourceCount) {
        this.resourceDetailDate = new Date(new Date().setHours(0, 0, 0, 0)).toISOString();
      }

      const profileValues = this.projectInformationForm.value;
      profileValues.srs = this.srs;
      profileValues.plan = this.plan;
      let activities = await this.getActivity(this.currentProjectDetails.projectInfo, profileValues);
      activities.forEach(element => {
        this.projectActivities.unshift(element);
      });
      const projectId = this.objectId;

      if (this.projectTypeCheck == 'Project') {
        let activities = await this.activityCenterService.getActivity(this.currentDetails, profileValues, this.hardCodedValues.project);
        this.activityCenterService.createActivity(activities, this.hardCodedValues.project, projectId);
      } else if (this.projectTypeCheck == 'Sub-Project') {
        let activities = await this.activityCenterService.getActivity(this.currentDetails, profileValues, this.hardCodedValues.addons);
        this.activityCenterService.createActivity(activities, this.hardCodedValues.addons, projectId);
      }

      const resourceDetails = {
        details: this.dataSources.data,
        resourceDetailDate: this.dateConvertor.addGMTOffset(new Date(this.resourceDetailDate)).toISOString()
      };

      let resourceDetailsActivity = await this.getActivityResource(this.currentResourcetDetails, resourceDetails.details);
      resourceDetailsActivity.forEach(element => {
        this.projectActivities.unshift(element);
      });

      if (this.projectTypeCheck == 'Project') {
        this.activityCenterService.createActivity(resourceDetailsActivity, this.hardCodedValues.project, projectId);
      } else if (this.projectTypeCheck == 'Sub-Project') {
        this.activityCenterService.createActivity(resourceDetailsActivity, this.hardCodedValues.addons, projectId);
      }

      const data = {
        projectInfo: {
          clientName: profileValues.clientName,
          projectName: profileValues.projectName,
          projectDescription: profileValues.projectDescription,
          projectType: profileValues.addOnType == 'Support' || profileValues.addOnType == 'Task' ? '' : profileValues.projectType,
          currentStatus: profileValues.currentStatus,
          projectPlatform: profileValues.projectPlatform,
          reason: profileValues.reason ? profileValues.reason : '',
          // projectStartDate: this.dateConvertor.addGMTOffset(new Date(profileValues.projectStartDate)).toISOString(),
          actualCompletionDate: profileValues.actualCompletionDate == null || profileValues.actualCompletionDate == '' ? '' : this.dateConvertor.addGMTOffset(new Date(profileValues.actualCompletionDate)).toISOString(),
          extendedCompletionDate: profileValues.extendedCompletionDate == null || profileValues.extendedCompletionDate == '' ? '' : this.dateConvertor.addGMTOffset(new Date(profileValues.extendedCompletionDate)).toISOString(),
          // srs: this.srs,
          // plan: this.plan,
          addOnType: profileValues.addOnType ? profileValues.addOnType : '',
        },
        resourceDetails: resourceDetails,
        activities: this.projectActivities
      };
      const id = this.empRole == 'Admin' ? this.objectId : this.projectId;

      if (this.projecttypeInfo != data.projectInfo.projectType) {
        this.toastr.info('Please change the resource type of assigned resources in this project');
      }

      this.projectInterface.updateProject(id, data).then(result => {
        this.getProjectInformation();

        if (profileValues.currentStatus == 'Completed') {
          this.statusdisable = true;
        }
      });
      if (this.isResourceChanged) {
        this.isResourceChanged = false;
      }

      this.toastr.success(this.toastMessage.Update);
      this.projectType.emit(this.projectInformationForm.value.projectType);
    } else if (errorArray.length > 0) {

      const validationArray = this.commonValidation.getValidation(errorArray);
      let toastvalue = '<h4>Please Check the Followings </h4> <ul>';
      validationArray.forEach(element => {
        toastvalue += '<li>' + element + ' </li>';
      });
      toastvalue += '</ul>';
      this.toastr.warning(toastvalue);
    }
  }

  resourceDetailcomparer(otherArray) {
    let projectType = this.projectInformationForm.value.projectType ? this.projectInformationForm.value.projectType : this.projectInformationForm.value.addOnType;
    return function (current) {
      return otherArray.filter(function (other) {
        if (projectType === 'Dedicated') {
          return other.role === current.role && other.count === current.count;
        }
        else if (projectType === 'Support') {
          return other.role === current.role && other.count === current.count;
        }
        else if (projectType === 'Fixed') {
          return other.role === current.role && other.count === current.count && other.hours === current.hours;
        }
      }).length === 0;
    };
  }

  checkCountDiff(oldValue, newValue, projectType) {
    let activities = []
    if (projectType === 'Dedicated') {
      newValue.forEach(newDetails => {

        oldValue.filter(oldDetails => {
          if (newDetails.role === oldDetails.role && newDetails.count !== oldDetails.count) {
            let message = 'Changed the ' + oldDetails.role + ' count ' + oldDetails.count + ' to ' + newDetails.count;
            activities.push(this.setActivityModel(message));
          }
        });
      });
    } else if (projectType === 'Fixed') {
      newValue.forEach(newDetails => {
        oldValue.filter(oldDetails => {
          if (newDetails.role === oldDetails.role && newDetails.count !== oldDetails.count) {
            let message = 'Changed the ' + oldDetails.role + ' count ' + oldDetails.count + ' to ' + newDetails.count;
            activities.push(this.setActivityModel(message));
          }
          if (newDetails.role === oldDetails.role && newDetails.hours !== oldDetails.hours) {
            let message = 'Changed the ' + oldDetails.role + ' Hours ' + oldDetails.hours + ' to ' + newDetails.hours;
            activities.push(this.setActivityModel(message));
          }
        });
      });

    }
    else if (projectType === 'Support') {
      newValue.forEach(newDetails => {

        oldValue.filter(oldDetails => {
          if (newDetails.role === oldDetails.role && newDetails.count !== oldDetails.count) {
            let message = 'Changed the ' + oldDetails.role + ' count ' + oldDetails.count + ' to ' + newDetails.count;
            activities.push(this.setActivityModel(message));
          }
        });
      });
    }
    return activities;
  }

  getActivityResource(oldValue, newValue) {
    let activities = [];
    let projectType = this.projectInformationForm.value.projectType ? this.projectInformationForm.value.projectType : this.projectInformationForm.value.addOnType;
    let countAndHourActivity = this.checkCountDiff(oldValue, newValue, projectType);

    if (countAndHourActivity.length > 0) {
      countAndHourActivity.forEach(element => {
        activities.unshift(element);
      });
    }
    if (oldValue.length !== newValue.length) {
      var onlyInA = oldValue.filter(this.resourceDetailcomparer(newValue));
      var onlyInB = newValue.filter(this.resourceDetailcomparer(oldValue));
      if (onlyInA.length > 0) {
        onlyInA.forEach(element => {
          let activityNew = [];
          let message;
          if (element.hours > 0) {
            message = ' Removed a role ' + element.role + ' Count - ' + element.count + ' ,Hours - ' + element.hours;
          } else {
            message = ' Removed a role ' + element.role + ' Count - ' + element.count;
          }
          activityNew.push(this.setActivityModel(message));
          activityNew.forEach(element => {
            activities.unshift(element);
          });
        });
      }
      if (onlyInB.length > 0) {
        onlyInB.forEach(element => {
          let activityNew = [];
          let message;
          if (element.hours > 0) {
            message = ' Added a role ' + element.role + ' Count - ' + element.count + ' ,Hours - ' + element.hours;
          }
          else {
            message = ' Added a role ' + element.role + ' Count - ' + element.count;
          }
          activityNew.push(this.setActivityModel(message));
          activityNew.forEach(element => {
            activities.unshift(element);
          });
        });
      }
    }
    return activities;
  }

  /*
  ** ==========================================================
  ** Create Project Information
  ** ==========================================================
  */
  createProjectInformation() {
    let allowSave = true;
    const errorArray = [];
    const controls = this.projectInformationForm.controls;
    if (this.projectInformationForm.value.addOnType == 'Support' || this.projectInformationForm.value.addOnType == 'Task') {
      for (const value in controls) {
        if (controls[value].invalid) {
          if (value != 'projectType') {
            allowSave = false;
            errorArray.push(value);
          }
        }
      }
    } else {
      for (const value in controls) {
        if (controls[value].invalid) {
          allowSave = false;
          errorArray.push(value);
        }
      }
    }
    if (this.dataSources.data.length <= 0) {
      allowSave = false;
      errorArray.push('Resources');
    }
    const roleCheck = this.dataSources.data.filter(a => a.role == '');
    const resourceCheck = this.dataSources.data.filter(a => a.count == 0);
    const hourCheck = this.dataSources.data.filter(a => a.hours == 0 || a.hours == null);
    if (roleCheck.length > 0) {
      allowSave = false;
      errorArray.push('Role');
    }
    if (resourceCheck.length > 0) {
      allowSave = false;
      errorArray.push('No Of Resources');
    }
    if (hourCheck.length > 0 && (this.projectInformationForm.value.projectType == 'Fixed' || this.projectInformationForm.value.addOnType == 'Task')) {
      allowSave = false;
      errorArray.push('Hours');
    }

    if (allowSave) {
      const profileValues = this.projectInformationForm.value;
      const profileValue = this.OtherInformationForm.value;
      const resourceDetails = {
        id: this.getRandomNumber(9),
        details: this.dataSources.data,
        resourceDetailDate: new Date()
      };

      const data = {
        projectInfo: {
          clientName: profileValues.clientName,
          projectDescription: profileValues.projectDescription,
          projectName: profileValues.projectName,
          projectType: profileValues.projectType,
          // currentStatus: profileValues.currentStatus,
          currentStatus: 'New',
          // projectPlatform: profileValues.projectPlatform,
          reason: profileValues.reason ? profileValues.reason : '',
          // projectStartDate: this.dateConvertor.addGMTOffset(profileValues.projectStartDate).toISOString(),
          // actualCompletionDate: profileValues.actualCompletionDate == '' || profileValues.actualCompletionDate == null ? '' : this.dateConvertor.addGMTOffset(profileValues.actualCompletionDate).toISOString(),
          // extendedCompletionDate: profileValues.extendedCompletionDate == '' || profileValues.extendedCompletionDate == null ? '' : this.dateConvertor.addGMTOffset(profileValues.extendedCompletionDate).toISOString(),
          // srs: this.srs,
          // plan: this.plan,
        },
        resourceDetails: resourceDetails
      };
      this.projectInformation = this.projectInformationForm.value;

      let activities = [];
      let message = 'Created a Project ' + this.projectInformation.projectName;
      let activity = this.activityCenterService.setActivityModel(message);
      activities.push(activity);

      const ProjectClass = this.parseService.instance.Object.extend('Project');
      var projectDetails = new ProjectClass();
      var client = new this.parseService.instance.Object('Client');
      client.id = profileValues.clientName;
      projectDetails.set('projectInfo', data.projectInfo);
      projectDetails.set('client', client);
      projectDetails.set('comments', []);
      projectDetails.set('projectType', 'Project');
      projectDetails.set('isActive', true);
      projectDetails.set('resourceDetails', data.resourceDetails);
      projectDetails.set('defaultProject', false);
      projectDetails.set('activities', activities);
      projectDetails.set('tenantId', this.tenantId);
      // if (profileValues.projectType == 'Dedicated') {
      //   projectDetails.set('schedulerStatus', 'Dedicated Billable');
      // }
      // if (profileValues.projectType == 'Fixed') {
      //   projectDetails.set('schedulerStatus', 'Fixed Billable');
      // }
      // else {
      //   projectDetails.set('schedulerStatus', '');
      // }
      // projectDetails.set('schedulerStatus', profileValues.projectType);
      if (profileValues.projectType == 'Fixed Billable') {
        projectDetails.set('schedulerStatus', 'Fixed Billable');
      }
      else if (profileValues.projectType == 'Fixed Non-Billable') {
        projectDetails.set('schedulerStatus', 'Fixed Non-Billable');
      }
      else if (profileValues.projectType == 'Time and Material Billable') {
        projectDetails.set('schedulerStatus', 'Time and Material Billable');
      }
      else if (profileValues.projectType == 'Time and Material Non-Billable') {
        projectDetails.set('schedulerStatus', 'Time and Material Non-Billable');
      }
      else {
        projectDetails.set('schedulerStatus', '');
      }
      projectDetails.save().then(res => {
        this.objectId = res.id;
        this.activityCenterService.createActivity(activities, this.hardCodedValues.project, this.objectId);

        this.isEditValue.emit((this.isEdit = true));
        this.isEditValue.emit((this.scrumBoard = false));
        this.router.navigate(['project-detail', { id: res.id, projectType: res.get('projectType') }]);
        this.createdProjectId.emit(this.objectId = res.id);
        this._scrumboardService.createScrumBoard(res);
        this.toastr.success('Project Created Successfully');
      },
      );
    } else {
      const validationArray = this.commonValidation.getValidation(errorArray);
      let toastvalue = '<h4>Please Check the Followings </h4> <ul>';
      validationArray.forEach(element => {
        toastvalue += '<li>' + element + ' </li>';
      });
      toastvalue += '</ul>';
      this.toastr.warning(toastvalue);
    }
  }

  /*
  ** ==========================================================
  ** Create scrumboard
  ** ==========================================================
  */
  createScrumboard() {
    this.queryInterface.executeQuery(this.parseService, 'Sprint', [{ condition: 'include', field: 'project' },
    { condition: 'equalTo', field: 'project', value: { __type: 'Pointer', className: 'Project', objectId: this.currentProjectDetails.id } }]).then(res => {
      if (res.length > 0) {
        this.toastr.warning('Backlogs already exist for this project')
      }
      else {
        this.dialog.closeAll();
        this._scrumboardService.createScrumBoard(this.currentProjectDetails);
        this.scrumBoard = false;
        this.router.navigate(['/scrumboard/board/analytics/' + this.projectId + '/' + this.projectName]);
      }
    });
  }

  scrumboardConfirmation() {
    this.dialog.open(this.scrumboard, {
      width: "300px"
    });
  }

  closs() {
    this.dialog.closeAll();
  }

  status(event) {
    if (this.projectReason !== '' && this.isEdit) {
      this.reason = true;
      this.projectInformationForm.controls['reason'].setValidators([Validators.required]);
      this.projectInformationForm.controls['reason'].updateValueAndValidity();
    }
  }

  statusChange(event) {
    if (event == 'Archived' && (this.nonBillableCount.length > 0 || (this.assignedResources.length - this.nonBillableCount.length) > 0)) {
      this.toastr.warning('Please release the assigned resource(s) before Archive the project.');
      this.projectInformationForm.patchValue({
        currentStatus: this.projectValue.projectInfo.currentStatus
      });
    }
    if (this.projectStatus !== event && this.isEdit) {
      this.reason = true;
      this.projectInformationForm.controls['reason'].setValidators([Validators.required]);
      this.projectInformationForm.controls['reason'].updateValueAndValidity();
      this.projectInformationForm.patchValue({
        reason: '',
      });
    }
    else {
      this.reason = false;
      this.projectInformationForm.controls['reason'].clearValidators();
      this.projectInformationForm.controls['reason'].updateValueAndValidity();
      this.projectInformationForm.patchValue({
        reason: this.previousReason,
      });
    }
  }

  closepopup(): void {
    this.dialog.closeAll();
  }

  /*
  ** ==========================================================
  ** Get Assigned Resource Details
  ** ==========================================================
  */
  getAssignedResources(projectId) {
    this.queryInterface.executeQuery(this.parseService, 'ProjectMembers', [
      { condition: 'equalTo', field: 'project', value: { __type: 'Pointer', className: 'Project', objectId: projectId } },
      { condition: 'equalTo', field: 'isActive', value: true },
      { condition: 'equalTo', field: 'status', value: 'Assigned' }]).then(results => {
        this.assignedResources = [];
        results.forEach(element => {
          const role = element.get('role');
          const userName = element.get('username');
          const status = element.get('status');
          const resourceType = element.get('resourcesType');
          this.assignedResources.push({ role: role, employeeName: userName, status: status, resourceType: resourceType });

          let projectType = this.projectInformationForm.value.projectType;
          this.nonBillableCount = this.assignedResources.filter(a => a.resourceType == (projectType == 'Dedicated' ? 'Dedicated-Billable' : 'Fixed-Billable'));
          this.supportBillableCount = this.assignedResources.filter(a => a.resourceType == 'Support-Billable');
          this.supportBillable = this.supportBillableCount.length;
        });
      });
  }

  getRandomNumber(val) {
    const timestamp = +new Date();
    length = val;
    var ts = timestamp.toString();
    var parts = ts.split('').reverse();
    var id = '';

    for (var i = 0; i < length; ++i) {
      var index = this.generateRandomNumber(0, parts.length - 1);
      id += parts[index];
    }
    return id;
  }

  generateRandomNumber(min, max) {
    return Math.floor(Math.random() * (max - min + 1)) + min;
  }

  async getResourceType() {
    let queryInstance = this.parseService.instance.Object.extend('DataSettings');
    let query = new this.parseService.instance.Query(queryInstance);
    let results = await query.find();
    const result = results[0];
    const resourceType = result.get('resourceRole');
    this.resourceDropdown = resourceType;
    if (this.dataSources.data.length > 0) {
      this.dataSources.data.forEach(element => {
        this.resourceDropdown.splice(
          this.resourceDropdown.findIndex(a => a == element.role),
          1
        );
      });
    }
  }

  keyPress(event: any) {
    const pattern = /[0-9\+\ ]/;
    const inputChar = String.fromCharCode(event.charCode);
    if (event.keyCode != 8 && !pattern.test(inputChar)) {
      event.preventDefault();
    }
  }

  /*
  ** ==========================================================
  ** Delete resource type
  ** ==========================================================
  */
  deleteResourceType(element) {
    const res = this.assignedResources.filter(x => x.role == element.role);
    if (res.length > 0) {
      const count = res.length;
      this.toastr.warning('Please release ( ' + count + ' ' + element.role + ' Resource ) before deleting role');
    } else {
      let data = [];
      data = this.dataSources.data;
      const index = data.findIndex(a => a.id == element.id);
      data.splice(index, 1);
      this.dataSources.data = data;
      if (element.role != '') {
        this.resourceDropdown.push(element.role);
      }
      this.isResourceChanged = true;
      this.changeCount(0, '');
      this.changeHourCount(0);
    }
  }

  /*
  ** ==========================================================
  ** Add resource type
  ** ==========================================================
  */
  addResourceType() {
    const data = this.dataSources.data;
    const id = this.getRandomNumber(9);
    data.push({
      id: id,
      role: '',
      count: 0,
      hours: 0
    });
    this.dataSources.data = data;
    this.isResourceChanged = true;
  }
  roleChange(event) {
    this.isResourceChanged = true;
    this.resourceDropdown.splice(
      this.resourceDropdown.findIndex(s => s == event),
      1
    );
  }

  /*
  ** ==========================================================
  ** Get activities
  ** ==========================================================
  */
  getActivity(oldValue, newValue): any[] {
    const activities = [];
    // tslint:disable-next-line: forin
    for (const oldproperty in oldValue) {
      for (const newproperty in newValue) {
        if (oldproperty === newproperty) {
          let activityModel = this.createActivity(oldproperty, oldValue[oldproperty], newValue[newproperty]);

          if (activityModel.allow) {
            if (activityModel.type === 'Array') {
              activityModel.activity.forEach(element => {
                activities.push(element);
              });

            } else {
              activities.push(activityModel.activity);
            }

          }
        }
      }
    }
    return activities;
  }

  /*
  ** ==========================================================
  ** Create activities
  ** ==========================================================
  */
  createActivity(property, oldValue, newValue): any {

    let message = '';
    let messages = [];
    let activity = {};
    let allow = false;
    const type = this.typeCheck((property === 'projectStartDate' || property === 'actualCompletionDate' || property === 'extendedCompletionDate') ? newValue._d : newValue);
    switch (type) {

      case 'string':
        if (oldValue !== newValue) {
          switch (property) {
            case 'clientName':
              const newClientName = this.clientList.filter(x => x.id === newValue);
              const oldClinetName = oldValue !== '' ? this.clientList.filter(x => x.id === oldValue) : '';
              // tslint:disable-next-line: max-line-length
              message = oldClinetName === '' ? 'Added a Client Name - ' + newClientName[0].name : 'Changed client name from ' + oldClinetName[0].name + ' to ' + newClientName[0].name;
              break;

            case 'projectName':
              const oldProjectName = oldValue !== '' ? oldValue : '';
              const newProjectName = newValue;
              message = oldProjectName === '' ? 'Added a Project Name - ' + newProjectName : 'Changed project name from ' + oldProjectName + ' to ' + newProjectName;
              break;

            case 'projectDescription':
              const oldProjectDescription = oldValue !== '' ? oldValue : '';
              const newProjectDescription = newValue;
              // tslint:disable-next-line: max-line-length
              message = oldProjectDescription === '' ? 'Added a Project Description - ' + newProjectDescription : 'Changed project description from ' + oldProjectDescription + ' to ' + newProjectDescription;
              break;

            case 'reason':
              const oldReason = oldValue !== '' ? oldValue : '';
              const newReason = newValue;
              // tslint:disable-next-line: max-line-length
              message = oldReason === '' ? 'Added a Project Reason - ' + newReason : 'Changed project reason from ' + oldReason + ' to ' + newReason;
              break;

            case 'projectType':
              const oldProjecType = oldValue !== '' ? this.projectLists.filter(x => x.value === oldValue) : '';
              const newProjectType = this.projectLists.filter(x => x.value === newValue);
              // tslint:disable-next-line: max-line-length
              if (newProjectType.length > 0) {
                message = oldProjecType === '' ? 'Added a Project Type - ' + newProjectType[0].value : 'Changed project type from ' + oldProjecType[0].value + ' to ' + newProjectType[0].value;
              }
              break;

            case 'currentStatus':
              const oldStatus = oldValue !== '' ? this.projectStatusList.filter(x => x.value === oldValue) : '';
              const newStatus = this.projectStatusList.filter(x => x.value === newValue);
              message = oldStatus === '' ? 'Added a Current Staus - ' + newStatus[0].value : 'Changed current status from ' + oldStatus[0].value + ' to ' + newStatus[0].value;
              break;

            case 'addOnType':
              const newAddOnType = this.addons.filter(x => x.value === newValue);
              const oldAddOnType = oldValue !== '' ? this.addons.filter(x => x.value === oldValue) : '';
              // tslint:disable-next-line: max-line-length
              message = oldAddOnType === '' ? 'Added a AddOn Type - ' + newAddOnType[0].value : 'Changed AddOn Type from ' + oldAddOnType[0].value + ' to ' + newAddOnType[0].value;
              break;
          }
          allow = true;
        }
        break;

      case 'Date':
        const datePipe = new DatePipe('en-US');
        const oldDate = datePipe.transform(oldValue, 'MMM dd yyyy');
        const newDate = datePipe.transform(newValue._d, 'MMM dd yyyy');
        if (oldDate !== newDate) {
          message = oldValue === '' ? 'Added a ' + property : 'Updated the ' + property + ' from ' + oldDate + ' to ' + newDate;
          allow = true;
        }
        break;

      case 'Array':
        switch (property) {
          case 'projectPlatform':
            let arrayValue = [];
            arrayValue = this.arrayDifference(oldValue, newValue);
            arrayValue.forEach(element => {
              const val1 = oldValue.includes(element);
              const val2 = newValue.includes(element);
              messages.push(val1 === false && val2 === true ? 'Added a ' + property + ' - ' + element : 'Removed a ' + property + ' - ' + element);
            });
            allow = true;
            break;

        }
        break;

    }

    if (type === 'Array') {
      let act = [];
      messages.forEach(element => {
        act.push(this.setActivityModel(element));
      });
      activity = act;
      return { activity: activity, allow, type };
    } else {
      activity = this.setActivityModel(message);
      return { activity: activity, allow, type };
    }

  }


  comparer(otherArray) {
    return function (current) {
      return otherArray.filter(function (other) {
        return other.value == current.value && other.display == current.display
      }).length == 0;
    }
  }

  typeCheck(Source): string {
    if (Source != null) {
      if (Source.constructor === Array) {
        return 'Array';
      } else if (Source.constructor === Object) {
        return 'object';
      } else if (Source.constructor === String) {
        return 'string';
      } else if (Source.constructor === Date) {
        return 'Date';
      } else if (Source.constructor === Number) {
        return 'Number';
      }
    }
  }

  /*
  ** ==========================================================
  ** Array Difference
  ** ==========================================================
  */
  arrayDifference(array1, array2) {
    let array = [];
    array1 = array1.toString().split(',');
    array2 = array2.toString().split(',');
    // for array1
    for (let i in array1) {
      if (array2.indexOf(array1[i]) === -1) {
        array.push(array1[i]);
      }
    }
    // for array2
    for (let i in array2) {
      if (array1.indexOf(array2[i]) === -1) {
        array.push(array2[i]);
      }
    }
    return array.sort((x, y) => x - y);
  }

  /*
  ** ==========================================================
  ** Activity Model
  ** ==========================================================
  */
  setActivityModel(message): any {
    const createrProfile = this.currentUser.get('profile');
    const createrImg = createrProfile.get('profileImageInfo').url;
    const createrName = createrProfile.get('username');
    const activity = {
      message: message,
      createdBy: createrName,
      createdId: createrProfile.id,
      createdDate: new Date().toUTCString(),
      createrImgUrl: createrImg == undefined ? this.hardCodedValues.defaultProfileImg : createrImg
    };
    return activity;
  }

}

export interface resourceTableModel {
  id: any;
  role: string;
  count: number;
  hours: number;
}

